import { groupedRoleOptions, ORBIT_LEVELS, LEVEL_STYLE, orbitRole } from "@/lib/roles";

export const RoleBadge = ({ u }) => {
  const r = orbitRole(u?.orbit_role);
  if (!r) return <span className="px-2 py-0.5 rounded-md bg-slate-100 text-[10px] font-bold uppercase">{u?.role}{u?.sub_role ? ` · ${u.sub_role}` : ""}</span>;
  return <span className="inline-flex items-center gap-1.5"><span className={`px-1.5 py-0.5 rounded text-[10px] font-bold ${LEVEL_STYLE[r.level]}`}>N{r.level}</span><span className="text-xs font-semibold">{r.label}</span></span>;
};

export function OrbitRoleSelect({ value, onChange, testId = "orbit-role-select", className = "" }) {
  return (
    <select data-testid={testId} value={value || ""} onChange={e => onChange(e.target.value)} className={`w-full h-11 px-3 rounded-xl border border-slate-200 text-sm bg-white ${className}`}>
      <option value="">— Choisir un rôle —</option>
      {groupedRoleOptions().map(g => (
        <optgroup key={g.level} label={g.label}>
          {g.roles.map(r => <option key={r.key} value={r.key}>{r.label}</option>)}
        </optgroup>
      ))}
    </select>
  );
}

export const roleHint = (key) => { const r = orbitRole(key); return r ? `Niveau ${r.level} · ${ORBIT_LEVELS[r.level]} — ${r.level === 4 ? "interface magasin" : "interface manager / direction"}` : ""; };
